if (document.getElementById('fad-map-full')) {

    let selectedFilters = {
        specialist_areas: null,
        other_services: null,
        insurance_companies: null,
        diagnostic_services: null,
        clinic_types: null
    };

    window.fad = {
        searchEl: document.getElementById('fad-search'),
        clinicResultEl: document.getElementById('fad-doctors-list'),
        noResultEl: document.getElementById('no-result-text'),
        loaderEl: document.getElementById('map-loader'),
        fullMapEl: document.getElementById('fad-map-full'),

        // token: to be changed later
        alkAppToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiOWU1ZGM2ZTFiZTY2YjIxZjkyYTA4N2YzYmY2ZGMyOGU5ODdlNTI2YTc2NWE1M2UyNGU2YjEwOTRmOTk1YjBmZTY4OTYxY2FmZTM0MGI2Y2MiLCJpYXQiOjE2NzcxMzgzOTMuODE0MTgyLCJuYmYiOjE2NzcxMzgzOTMuODE0MTgzLCJleHAiOjE3MDg2NzQzOTMuODEwNzksInN1YiI6IjgiLCJzY29wZXMiOltdfQ.4yGmK2sIz8DFOl-4umJfKGfi2tcYch0Ciwf5hP5Nr52kd2FDjAPG1dXKEjDxuWudbk5rcmyqcHE66VCOtT_ifDFWFVvS59qbhdJxZpm2BZHPQeypJB94YJtFDGlBFLJgXGnhZygFPIOjWR5KKontb23foG7WDHylMyPEE29jNwrEcGf8REqv0c9v6KrKmD0o4cYTiIlKwdBMnSbZ9cChtH4JUCg0O0LCIIDWgP06Bmq4CVrEO3oO5Canj3zg4e2Zy1SogR1Spx6xCswznxzzsZdU9B3M3dBIL0R8r-7crlPtQUXoY-3Bu8sZYwCnjx4CX2zTCNCykGj0Yk4F1cFkEBcuz1TmuOAgSRzzTjKZFHCSYT51ITMg1bih7slFOso727dlZNDA36CCECXJ9EeHmOQI2QLqtmdGAuWaIMoTxSa7jSQeWP0tbVBPSgHoePHaotYFjFew9sVythV0nezUhR4t5v32mhsZHKwM2uJNQ8_Dhx-1hq-Q5N2Nh7x2VlNPzC2ORVIVEsaF3IKy9U2kTnYNwuO6dNDDq9FdoaTFCTAytmpSl_pLmj6QXeH3SYAVkySGGOfA_8aAKENpkh7whWckC27ANwzgXZQSWMYhetNhdZZQopxHwtKCbj3sGMsVa6Nv4YK9HKzIQxvckF0l6fHkgtJIUnKka8qiJddv6cE',

        countryBounds: {
            north: parseFloat(`70.462899`),
            south: parseFloat(`24.521208`),
            east: parseFloat(`-66.945392`),
            west: parseFloat(`-142.183106`),
        },

        defaultZoom: parseInt(`10`),


        map: null,
        data: [],
        markers: [],
        marker: null,
        isMarkerOpening: false,
        // userLocation: {
        //     lat: null,
        //     lng: null
        // },
        userLocation: {
            lat: parseFloat(`40.712775`),
            lng: parseFloat(`-74.005973`)
        },

        regionLocation: null,
        apiParams: {
            lat: null,
            lng: null,
            radius: 20000,
            region: '',
        },
        filters: null,
        selectedFilters: selectedFilters,
        params: Object.fromEntries(new URLSearchParams(window.location.search).entries()),
        geocoder: new google.maps.Geocoder(),
        runOnce: false,

        async init() {

            await this.setUserLocation();

            if (this.fullMapEl) {
                await this.bindFilterEvents();
                if (this.filters == null)
                    await this.getFilters()

            }
            this.setSearchBox();
            this.setMap();

            if (this.fullMapEl) {

                if (window.screen.width <= 767) document.getElementById('fad-map-list').classList.add('d-none');
                document.getElementById('list-change-btn').addEventListener('click', (event) => {

                    event.currentTarget.querySelectorAll('.list-change-btn span').forEach((span) => span.classList.toggle('d-none'));
                    document.getElementById('fad-map-list').classList.toggle('d-none');
                    // if(document.getElementById('fad-map').classList.contains('d-none')) 
                    document.getElementById('fad-map').classList.toggle('d-none');

                });

            }

            if (this.params.city) {

                // let geocoder = new google.maps.Geocoder();
                this.geocoder.geocode({ 'address': this.params.city, componentRestrictions: { country: window.countryCode } }, (results, status) => {

                    if (status.toLowerCase() === 'ok') {
                        this.searchEl.value = this.params.city;
                        this.map.fitBounds(results[0].geometry.viewport);
                    }
                });
            } else {
                this.handleSearch(null);
            }
        },

        async setUserLocation() {

            let userLocationLat = Utility.getCookie('userLocationLat');
            let userLocationLng = Utility.getCookie('userLocationLng');
            let userLocationCity = Utility.getCookie('userLocationCity');
            let userLocationCountry = Utility.getCookie('userLocationCountry');

            if (userLocationLat && userLocationLng && userLocationCity && userLocationCountry) {

                this.userLocation = {
                    lat: parseFloat(userLocationLat),
                    lng: parseFloat(userLocationLng),
                };

            } else {

                let response = await fetch(`https://api.ipstack.com/check?access_key=${window.ipCheckAPIKey}`);
                response = await response.json();

                if (response.country_name !== window.countryName) {

                    response.latitude = window.defaultUserLocation.lat;
                    response.longitude = window.defaultUserLocation.lng;
                    response.city = window.defaultCity;
                    response.country_name = window.countryName;
                }

                this.userLocation = {
                    lat: response.latitude,
                    lng: response.longitude,
                };

                Utility.setCookie('userLocationLat', parseFloat(response.latitude).toFixed(8), 30);
                Utility.setCookie('userLocationLng', parseFloat(response.longitude).toFixed(8), 30);
                Utility.setCookie('userLocationCity', response.city, 30);
                Utility.setCookie('userLocationCountry', response.country_name, 30);
                userLocationLat = response.latitude;
                userLocationLng = response.longitude;
                userLocationCity = response.city;
                // userLocationCountry = response.country_name;
                userLocationCountry = 'United States';

            }

            if (!this.params.city && userLocationCountry === window.countryName) {

                let latlng = {
                    lat: parseFloat(userLocationLat),
                    lng: parseFloat(userLocationLng),
                };

                await this.geocoder.geocode({ location: latlng }, async (results, status) => {
                    this.params.city = results.length ? results[0].formatted_address : '';

                    results.forEach(result => {
                        if (result.types.length === 2 && result.types.includes('locality')) {
                            // console.log(result);
                            this.searchEl.value = result.formatted_address;
                            this.params.city = result.formatted_address;
                            return false;
                        }
                    });
                });
            }
        },

        setSearchBox() {

            let options = {
                componentRestrictions: { country: window.countryCode },
                fields: ['geometry'],
                strictBounds: false,
            }
            let autocomplete = new google.maps.places.Autocomplete(this.searchEl, options);
            autocomplete.addListener('place_changed', () => {

                this.selectedFilters = selectedFilters;
                this.handleRedirectOrUpdate(this.searchEl.value);

                this.isMarkerOpening = false;
                if (this.searchEl.value) {
                    let place = autocomplete.getPlace();
                    this.map.fitBounds(place.geometry.viewport);
                    if (this.fullMapEl) document.getElementById('fad-filters-btn').removeAttribute('disabled');
                } else {
                    this.map.panTo({ lat: this.userLocation.lat, lng: this.userLocation.lng });
                    if (this.fullMapEl) document.getElementById('fad-filters-btn').setAttribute('disabled', '');
                    if (this.clinicResultEl) this.clinicResultEl.innerHTML = '';
                }
            });
        },

        openFirst() {
            let docID = document.querySelector('.search-data-block').getAttribute('data-id');
            document.querySelector('.search-data-block').click();
            this.markers.forEach(marker => {
                if (parseInt(marker.id) === parseInt(docID)) this.openMarkerInfoWindow(marker);
            });
            this.runOnce = true;
        },

        setMap() {
            let zoomControlvalue = (window.screen.width <= 767) ? false : true;
            let centerVlaue = this.userLocation;

            // if (this.isRegionPage || this.isCityPage ) centerVlaue =  this.regionLocation;

            this.map = new google.maps.Map(document.getElementById('fad-map'), {
                gestureHandling: 'cooperative',
                zoomControl: zoomControlvalue,
                scaleControl: false,
                mapTypeControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                center: centerVlaue,
                zoom: this.defaultZoom,
                restriction: {
                    latLngBounds: this.countryBounds,
                    strictBounds: false,
                },
            });

            new google.maps.Marker({
                map: this.map,
                position: this.userLocation,
                id: 'user-location',
                optimized: false,
            });

            this.map.addListener('idle', async () => {

                if (this.loaderEl) this.loaderEl.classList.remove('d-none');

                if (this.isMarkerOpening) {

                    this.isMarkerOpening = false;
                    if (this.loaderEl) this.loaderEl.classList.add('d-none');
                    return;
                }

                this.apiParams.lat = this.map.getCenter().lat();
                this.apiParams.lng = this.map.getCenter().lng();

                let vr = this.map.getBounds();
                let north = vr.getNorthEast().lat();
                let south = vr.getSouthWest().lat();
                let east = vr.getNorthEast().lng();
                let west = vr.getSouthWest().lng();
                let northSouth = north - south;
                let eastWest = east - west;

                if (eastWest < northSouth) north = south = 0;
                else east = west = 0;

                this.apiParams.radius = google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(north, east), new google.maps.LatLng(south, west));
                if (this.apiParams.radius > window.defaultSearchRadius) this.apiParams.radius = window.defaultSearchRadius;

                if (document.getElementById('fad-search').value) await this.updateRecords();
                else this.handleSearch(null);

                // if (this.isRegionPage || this.isCityPage) google.maps.event.clearListeners(this.map, 'idle');               
            });

        },

        bindFilterEvents() {

            document.getElementById('fad-filters-btn').addEventListener('click', () => {

                if (document.querySelector('[fad-doctor-all-filters]').innerHTML == '')
                    this.filtersHTML();

                // this.filterOptions()
                this.toggleFilters()
            });


            document.getElementById('fad-filters-reset-btn').addEventListener('click', () => {

                document.querySelectorAll('#filter-container input:checked').forEach(el => el.checked = false);
                // document.getElementById('klinikk-options').classList.add('d-none');
                // document.querySelector('#klinikk-options input[value=""]').click();
                selectedFilters = [];
                this.selectedFilters = selectedFilters;

                this.toggleFilters();
                this.updateRecords();
            });

            document.getElementById('fad-filters-apply-btn').addEventListener('click', () => {

                selectedFilters = [];
                this.selectedFilters = selectedFilters;

                document.querySelectorAll('#filter-container .custom-radio input').forEach((el) => {

                    let filterParam = el.attributes.name.value;
                    if (filterParam === 'specialist_areas' && el.checked) this.selectedFilters.specialist_areas = el.value;
                    if (filterParam === 'clinic_types' && el.checked) this.selectedFilters.clinic_types = el.value;
                    if (filterParam === 'other_services' && el.checked) this.selectedFilters.other_services = el.value;
                    if (filterParam === 'insurance_companies' && el.checked) this.selectedFilters.insurance_companies = el.value;
                    if (filterParam === 'diagnostic_services' && el.checked) this.selectedFilters.diagnostic_services = el.value;

                });
                this.toggleFilters();
                this.updateRecords();
            });

            document.getElementById('close-filter').addEventListener('click', () => {

                document.getElementById('filter-container').classList.add('d-none');
                document.getElementById('list-container').classList.remove('d-none');
                if (window.screen.width <= 767) {
                    if (document.getElementById('fad-map-list').classList.contains('d-none')) document.getElementById('map-block').classList.toggle('d-none');
                }
            });


        },

        async getFilters() {

            let response = await fetch(`https://alk-app.klarify.me/api/clinics/filters`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${this.alkAppToken}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            response = await response.json();
            this.filters = response;
        },

        filtersHTML() {

            let filters = this.filters;
            let filtersHTML = '';
            let specialist_areas_html = '';
            let other_services_html = '';
            let insurance_companies_html = '';
            let diagnostic_services_html = '';
            let clinic_types_html = '';

            Object.entries(filters).forEach(([key, values]) => {
                // console.log(`${key}: ${values}`);

                switch (key) {
                    case 'specialist_areas':
                        if (values != null) {
                            values.forEach((value, index) => {
                                // console.log(value, index);
                                specialist_areas_html += `
                              <div class="custom-control font-size-sm mb-2 custom-radio ps-0">
                                  <input type="radio" reset-form id="specialist-option-${index}" data-filter-radio  value="${value}" name="${key}" class="custom-control-input">
                                  <label class="custom-control-label ps-4 fw-bold" for="specialist-option-${index}">${value}</label>
                              </div>
                              `
                            });
                        }
                        break;

                    case 'other_services':
                        if (values != null) {
                            values.forEach((value, index) => {
                                // console.log(value, index);
                                other_services_html += `
                              <div class="custom-control font-size-sm mb-2 custom-radio ps-0">
                                  <input type="radio" reset-form id="other-services-option-${index}" data-filter-radio value="${value}" name="${value}" class="custom-control-input">
                                  <label class="custom-control-label ps-4 fw-bold" for="other-services-option-${index}">${value}</label>
                              </div>
                              `
                            });
                        }
                        break;

                    case 'insurance_companies':
                        if (values != null) {
                            values.forEach((value, index) => {
                                // console.log(value, index);
                                insurance_companies_html += `
                              <div class="custom-control font-size-sm mb-2 custom-radio ps-0">
                                  <input type="radio" reset-form id="insurance-companies-option-${index}" data-filter-radio value="${value}" name="${value}" class="custom-control-input">
                                  <label class="custom-control-label ps-4 fw-bold" for="insurance-companies-option-${index}">${value}</label>
                              </div>
                              `
                            });
                        }
                        break;

                    case 'diagnostic_services':
                        // let diagnostic_services_html = '';
                        if (values != null) {
                            values.forEach((value, index) => {
                                // console.log(value, index);
                                diagnostic_services_html += `
                              <div class="custom-control font-size-sm mb-2 custom-radio ps-0">
                                  <input type="radio" reset-form id="diagnostic-services-option-${index}" data-filter-radio value="${value}" name="${value}" class="custom-control-input">
                                  <label class="custom-control-label ps-4 fw-bold" for="diagnostic-services-option-${index}">${value}</label>
                              </div>
                              `
                            });
                        }
                        break;

                    case 'clinic_types':
                        if (values != null) {
                            values.forEach((value, index) => {
                                // console.log(value, index);
                                clinic_types_html += `
                              <div class="custom-control font-size-sm mb-2 custom-radio ps-0">
                                  <input type="radio" reset-form id="clinic-types-option-${index}" data-filter-radio value="${value}" name="${value}" class="custom-control-input">
                                  <label class="custom-control-label ps-4 fw-bold" for="clinic-types-option-${index}">${value}</label>
                              </div>
                              `
                            });
                        }
                        break;

                    default:
                        break;
                }
            });

            filtersHTML = `
              
              ${specialist_areas_html ? `<p class="text-uppercase fw-bold font-size-sm mb-2">Services</p>` : ''}
              ${specialist_areas_html ? `<div class="major_specialty" fad-doctor-specialist> ${specialist_areas_html ? specialist_areas_html : ''} </div>` : ''}

              ${other_services_html ? `<p class="text-uppercase fw-bold font-size-sm mb-2">Other Services</p>` : ''}
              ${other_services_html ? `<div class="major_specialty" fad-doctor-specialist> ${other_services_html ? other_services_html : ''} </div>` : ''}

              ${insurance_companies_html ? `<p class="text-uppercase fw-bold font-size-sm mb-2">Insurance Type</p>` : ''}
              ${insurance_companies_html ? `<div class="major_specialty" fad-doctor-specialist> ${insurance_companies_html ? insurance_companies_html : ''} </div>` : ''}

              ${diagnostic_services_html ? `<p class="text-uppercase fw-bold font-size-sm mb-2">Diagnostic Services</p>` : ''}
              ${diagnostic_services_html ? `<div class="major_specialty" fad-doctor-specialist> ${diagnostic_services_html ? diagnostic_services_html : ''} </div>` : ''}

              ${clinic_types_html ? `<p class="text-uppercase fw-bold font-size-sm mb-2">Clinic Type</p>` : ''}
              ${clinic_types_html ? `<div class="major_specialty" fad-doctor-specialist> ${clinic_types_html ? clinic_types_html : ''} </div>` : ''}
                  
          `;
            document.querySelector('[fad-doctor-all-filters]').innerHTML = filtersHTML;
        },

        filterOptions() {

            if (document.querySelector('[fad-doctor-specialist]').innerHTML == '')
                this.filtersHTML();



            let specialistAreas = window.doctorFilterOptions['specialist_areas'];
            if (document.querySelector('[fad-doctor-specialist]').innerHTML == '') {
                let doctorFilterSpecialistList = '';
                specialistAreas.forEach((specialist, index) => {
                    doctorFilterSpecialistList += ` 
              <div class="custom-control font-size-sm mb-2 custom-radio ps-0">
                  <input type="radio" reset-form id="specialist-option-${index}" data-filter-radio  value="${specialist}"  name="fad-filters-specialities" class="custom-control-input">
                  <label class="custom-control-label ps-4 fw-bold" for="specialist-option-${index}">${specialist}</label>
              </div>
              `;
                });
                document.querySelector('[fad-doctor-specialist]').innerHTML = doctorFilterSpecialistList;
            }
        },

        toggleFilters() {

            document.getElementById('list-container').classList.toggle('d-none');
            document.getElementById('filter-container').classList.toggle('d-none');
            if (window.screen.width <= 767) {
                if (document.getElementById('fad-map-list').classList.contains('d-none')) document.getElementById('map-block').classList.toggle('d-none');
            }
        },

        // left as it it - will come late, 
        async updateRecords() {

            let selectedFilters = [];

            // return
            for (let filter in this.selectedFilters) {

                if (this.selectedFilters[filter] !== null) {

                    if (this.selectedFilters[filter] !== '') selectedFilters.push(`&${filter}=${this.selectedFilters[filter]}`);

                    // if (filter === 'clinic_types') {

                    //     if (this.selectedFilters[filter] !== '') selectedFilters.push(`&${filter}=${this.selectedFilters[filter]}`);
                    // } 
                    // else if(filter !== 'distance'){

                    //     filters.push(`&${filter}=${parseInt(this.filters[filter])}`);
                    // }

                }
            }
            // if (this.filters.distance)  this.apiParams.radius = this.filters.distance

            let response = await fetch(`https://alk-app.klarify.me/api/clinics?country=${window.countryCode}&region=${this.apiParams.region}&latitude=${this.apiParams.lat}&longitude=${this.apiParams.lng}&radius=${this.apiParams.radius}${selectedFilters.join('')}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${this.alkAppToken}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            response = await response.json();
            if (this.loaderEl) this.loaderEl.classList.add('d-none');
            this.clearRecords();

            // if (this.marker && !response.clinics.some(item => item.id === this.marker.id)) response.clinics.push(this.data[0]);


            if (response.clinics.length) {

                if (this.noResultEl) this.noResultEl.innerText = '';
                this.data = response.clinics;
                let clinicsHTML = '';

                this.data.forEach((clinic, k) => {

                    let phoneHTML = '';
                    if (clinic.phone) {

                        phoneHTML = `
                        <div class="d-flex align-items-center mb-1 pt-2 phone-block">
                            <i class="icon-phone text-gray-500"></i>
                            <p class="mb-0 ps-2 font-size-md">
                                <a href="tel:${clinic.phone}" class="text-primary fw-medium" data-clinic="${k}">${clinic.phone}</a>
                            </p>
                        </div>
                    `;
                    }
                    let doctorName = '';
                    doctorName = `
                    <div class="d-flex justify-content-between border-bottom border-gray-400 pb-2">
                        <div>
                            <h6 class="text-capitalize fw-medium mb-1 ls-0">${clinic.doctor_name}</h6>
                            ${(clinic.specialist_areas.length) ? `<p class="fw-light text-gray-600 font-size-md mb-0 ls-0">${clinic.specialist_areas.join(', ')}</p>` : ''}
                        </div>
                    </div>
                `;

                    let addressHTML = '';
                    addressHTML = `
                    <div class="position-relative ls-0">
                        <div class="d-flex align-items-start mb-1">
                            <i class="icon-location-pin text-gray-500"></i>
                            <div class="d-flex flex-column">
                                <p class="fw-light mb-0 ps-2 font-size-md">${clinic.street}</p>
                                <p class="fw-light mb-0 ps-2 font-size-md"> ${clinic.city}, ${clinic.state} ${clinic.zipcode}</p>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center mt-2">

                            <a target="_blank" href="https://www.google.com/maps/dir/${this.userLocation.lat},${this.userLocation.lng}/${clinic.latitude},${clinic.longitude}/data=!3m1!4b1!4m2!4m1!3e0" class="btn doctor_direction text-capitalize me-2">${clinic.distance ? `${clinic.distance}km` : 'Route'} <i class="icon-location-pin"></i></a>

                            <!-- <a target="_blank" href="https://www.google.com/maps/place/${clinic.latitude},${clinic.longitude}" class="btn doctor_direction text-capitalize me-2">${clinic.distance ? `${clinic.distance}km` : 'Route'} <i class="icon-location-pin"></i></a>
                            -->
                        </div>
                    </div>
                `;

                    let clinicHTML = '';
                    clinicHTML = `
                    <li class="list-group-items list-unstyled doctor_list search-data-block" id="clinic-${clinic.id}" data-clinic-name="${clinic.clinic_name}" data-doctor-name="${clinic.doctor_name}" data-id="${clinic.id}">
                        
                        <div class="list-items--item mx-0 mx-md-3 mb-3 p-3">
                            <div class="lower-index marker-trigger"></div>
                                ${doctorName}
                                ${phoneHTML}
                                ${addressHTML}
                            </div>
                        </div>
                    </li>
                `;

                    clinicsHTML += clinicHTML;

                    let marker = new google.maps.Marker({
                        map: this.map,
                        position: {
                            lat: parseFloat(clinic.latitude),
                            lng: parseFloat(clinic.longitude),
                        },
                        id: clinic.id,
                        url: `#clinic-${clinic.id}`,
                        optimized: false,
                        icon: {
                            url: 'https://cdn.shopify.com/s/files/1/0559/4624/8297/files/map-location.svg?v=1661663065',
                            scaledSize: new google.maps.Size(40, 40)
                        },
                        disableAutoPan: true,
                    });

                    google.maps.event.addListener(marker, 'click', function () {

                        window.fad.openMarkerInfoWindow(this);
                        if (document.getElementById("fad-map-full")) {

                            let current = document.querySelector(marker.url);
                            let offset = current.offsetTop;
                            document.getElementById('fad-map-list').scroll(0, (offset - window.fad.clinicResultEl.offsetTop));
                            // window.fad.clinicResultEl.scroll(0, (offset - window.fad.clinicResultEl.offsetTop));
                        }
                    });
                    this.markers.push(marker);

                });

                if (this.clinicResultEl) {
                    if (this.marker) this.marker.infoWindow.close();
                    this.clinicResultEl.innerHTML = '';
                    this.clinicResultEl.innerHTML = clinicsHTML;
                    if(!this.runOnce) {
                        this.openFirst();
                    }
                }

                document.querySelectorAll('.search-data-block').forEach(clinicItemEl => {

                    let doctorID = parseInt(clinicItemEl.getAttribute('data-id'));

                    clinicItemEl.querySelectorAll('.marker-trigger').forEach((clickableEl) => {

                        clickableEl.addEventListener('click', (event) => {

                            console.log('card clicked');

                            this.markers.forEach(marker => {

                                if (parseInt(marker.id) === doctorID) this.openMarkerInfoWindow(marker);
                            });

                        });
                    });
                });

            } else {

                if (this.clinicResultEl) this.clinicResultEl.innerHTML = '';
                if (this.noResultEl) this.noResultEl.innerText = 'No entries found.';
            }
        },

        async handleSearch(value) {

            if (!value) {

                if (this.noResultEl) this.noResultEl.innerText = 'Enter city/zip code';
                if (this.clinicResultEl) this.clinicResultEl.innerHTML = '';
                this.clearRecords();
            } else {

                if (this.noResultEl) this.noResultEl.innerText = '';
                if (this.clinicResultEl) this.clinicResultEl.innerHTML = '';
                await this.updateRecords();

                let markerBounds = new google.maps.LatLngBounds();
                this.markers.forEach(marker => markerBounds.extend({ lat: marker.getPosition().lat(), lng: marker.getPosition().lng() }));
                this.map.fitBounds(markerBounds);
            }
        },

        openMarkerInfoWindow(marker) {
            if (this.marker) {

                if (this.marker.id === marker.id) return;
                else this.marker.infoWindow.close();
            }

            if (this.fullMapEl) {

                document.querySelectorAll('.search-data-block.active').forEach(el => el.classList.remove('active'));
                document.querySelector(marker.url).classList.add('active');
            }

            let infoWindow = new google.maps.InfoWindow({ content: this.buildInfoWindowContent(this.data.find(doctor => doctor.id === marker.id)) });
            infoWindow.addListener('closeclick', () => this.marker = null);
            marker.infoWindow = infoWindow;

            this.marker = marker;

            this.isMarkerOpening = true;
            marker.infoWindow.open(this.map, marker);
        },

        buildInfoWindowContent(clinic) {

            return `
              <div class="doctor_details">
                  <div class="d-flex align-items-center">
                      <div class="dialog-profile-content">
                          <h6 class="fw-medium lh-base ls-0 mb-1">${clinic.doctor_name}</h6>
                          <p class="font-size-md lh-base fw-medium text-gray-600 mb-0">${clinic.specialist_areas.join(', ')}</p>
                      </div>
                  </div>
                  <hr class="border-bottom border-gray-900 border-0" />
                  <p class="font-size-md lh-base fw-medium text-gray-600 mb-0">
                      ${clinic.phone ? `${clinic.phone}` : ''}
                  </p>
                  <p class="font-size-md lh-base fw-medium text-gray-600 mb-0">${clinic.street}</p>
                  <p class="font-size-md lh-base fw-medium text-gray-600 mb-0">${clinic.city}, ${clinic.state} ${clinic.zipcode}</p>
              </div>
          `;

        },

        clearRecords() {

            if (this.marker && this.searchEl.value) {

                for (let i = 0; i < this.markers.length; i++) {

                    if (this.markers[i].id !== this.marker.id) {
                        this.markers[i].setMap(null);
                    }
                }

                this.markers = this.markers.filter(marker => marker.id === this.marker.id);
                this.data = this.data.filter(item => item.id === this.marker.id);
            } else {

                this.marker = null;
                for (let i = 0; i < this.markers.length; i++) {
                    this.markers[i].setMap(null);
                }
                this.markers = [];
                this.data = [];
            }
            if (this.loaderEl) this.loaderEl.classList.add('d-none');
        },

        handleRedirectOrUpdate(search) {

            let pageHandle = window.location.href.substring(window.location.href.lastIndexOf('/') + 1).split('?')[0];
            if (this.fullMapEl && pageHandle !== 'find-doctor' && pageHandle !== '') {
                window.location.href = '/pages/find-doctor?search=' + search;
            }
        },

    };

    window.fad.init();
}